export default "__VITE_PUBLIC_ASSET__1723e9ff__"